export const REDUCER_NAME = 'security'



// WEBPACK FOOTER //
// ./src/modules/security/state/const.js